"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAutocomplete = void 0;
var colors_1 = require("../colors");
exports.MuiAutocomplete = {
    styleOverrides: {
        inputRoot: {
            '& .prism-search': {
                minWidth: 100,
            },
        },
        listbox: {
            padding: 8,
            '& .MuiAutocomplete-option': {
                '&.Mui-focusVisible': {
                    boxShadow: "0 0 0 2px ".concat(colors_1.tannerSemantic.info.color),
                    outline: "3px solid ".concat(colors_1.tannerWhite),
                    outlineOffset: 2,
                    backgroundColor: colors_1.tannerGray['100'],
                },
            },
        },
        endAdornment: {
            top: '50%',
            transform: 'translateY(-50%)',
        },
        tag: {
            margin: '2px 5px 2px 2px',
        },
    },
};
//# sourceMappingURL=MuiAutocomplete.js.map